export enum CenterOrganType {
    Kidney = 1,
    Liver = 2,
    Both = 3
}
